import { styled } from '@styles/stitches';

export const Container = styled('div', {});

export const List = styled('div', {
  flexShrink: 0,
  display: 'flex',
  borderBottom: '1px solid $colors$primaryBorder',
  overflowX: 'auto',
});

export const Tabs = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const Trigger = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  padding: '10px 20px',
  color: '$secondaryFill',
  userSelect: 'none',
  cursor: 'pointer',

  '&:focus': { outline: 0 },

  '&:hover': { color: '$primaryFill' },

  '&[data-state="active"]': {
    color: '$primaryFill',
    boxShadow: 'inset 0 -1px 0 0 currentColor, 0 1px 0 0 currentColor',
  },
});

export const Quantity = styled('div', {
  color: '$secondaryFill',
  marginLeft: 8,
  fontSize: 10,
});

export const Content = styled('div', {
  flexGrow: 1,
  padding: '$space$2 0 $space$1 0',

  '&:focus': { outline: 0 },
});
